<template>
    <iframe v-if="html && liveKit" :srcdoc="html" frameborder="0" width="100%" height="100%" :id="iframe_id" :class="{'full-width': videoChat == false}"></iframe>
</template>
<script>
export default {
    props: ['liveKit', 'videoChat','selectedTheme','conversation_id','api'],
    data() {
        return {
            html: '',
            iframe_id : Date.now()
        }
    },
    mounted() { 
        setTimeout(() => {
                this.$emit('resize-height');
        }, 50);
        if (this.liveKit) {
            this.html =  `<!doctype html>
            <html lang="en" >
            <head>
                <meta charset="utf-8" />
                <link rel="icon" href="/favicon.ico" />
                <meta name="viewport" content="width=device-width,initial-scale=1" />
                <meta name="theme-color" content="#000000" />
                <script defer src="https://cdn1.easychatrooms.com/assets/livekit/static/js/main.js?timestamp=${Date.now()}"></` + `script>
                <link href="https://cdn1.easychatrooms.com/assets/livekit/static/css/main.css" rel="stylesheet">
                <link href="https://cdn1.easychatrooms.com/assets/livekit/static/css/custom.css?timestamp=${Date.now()}" rel="stylesheet">
            </head>
            <body class="`+ (this.selectedTheme == 'dark' ? '' : 'light') + `">
                <noscript>You need to enable JavaScript to run this app.</noscript>
                <div id="root"></div>
                <script>
                    window.WStoken = "${this.liveKit.token}";
                    window.WSurl = "${this.api.LiveKitUrl}"; 
                    window.WSAudio = true;
                    window.WSVideo = ${this.liveKit.isVideo};
                    window.WSIsConferanceRoom = ${this.videoChat};
                    window.urlBASE = '${this.$socket_url}';
                    window.themeValue = '`+(this.selectedTheme == 'dark' ? 'default' : 'light') +`';
                </` + `script>
            </body>
            </html>`;
        } 
        
    },
    watch: {   
        selectedTheme(newValue) {
            const iframe = document.getElementById(this.iframe_id);
            if (!iframe) {
                return;
            }
            if(newValue == 'dark') {
                iframe.contentWindow.postMessage({ theme: 'dark' }, '*');
            } else {
                iframe.contentWindow.postMessage({ theme: 'light' }, '*');
            }
        },
        liveKit(newValue) {
            if (newValue) {
                this.html =  `<!doctype html>
                <html lang="en" >
                <head>
                    <meta charset="utf-8" />
                    <link rel="icon" href="/favicon.ico" />
                    <meta name="viewport" content="width=device-width,initial-scale=1" />
                    <meta name="theme-color" content="#000000" />
                    <script defer src="https://cdn1.easychatrooms.com/assets/livekit/static/js/main.js?timestamp=${Date.now()}"></` + `script>
                    <link href="https://cdn1.easychatrooms.com/assets/livekit/static/css/main.css" rel="stylesheet">
                    <link href="https://cdn1.easychatrooms.com/assets/livekit/static/css/custom.css?timestamp=${Date.now()}" rel="stylesheet">
                </head>
                <body class="`+ (this.selectedTheme == 'dark' ? '' : 'light') + `">
                    <noscript>You need to enable JavaScript to run this app.</noscript>
                    <div id="root"></div>
                    <script>
                        window.WStoken = "${this.liveKit.token}";
                        window.WSurl = "wss://easychatrooms-89sotbya.livekit.cloud";
                        window.WSAudio = true;
                        window.WSVideo = ${this.liveKit.isVideo};
                        window.WSIsConferanceRoom = ${this.videoChat};
                        window.urlBASE = '${this.$socket_url}';
                        window.themeValue = '`+(this.selectedTheme == 'dark' ? 'default' : 'light') +`';
                    </` + `script>
                </body>
                </html>`;
            }
            const self = this;
            setTimeout(() => {
                self.$emit('resize-height');
            }, 200);
        }       
    },
    unmounted() {
        this.$emit('resize-height');
    }
}




</script>

<style scoped>

iframe {
    min-height: 450px;
    max-width: 800px;
    margin: auto;
    border-radius: 0.75rem;
}

iframe.full-width {
    width: 100%;
    max-width: 100%;
}


@media screen and (min-width: 768px) {
    iframe {
        min-height: calc(100vh - 400px);
    }
}

</style>